import CargoClaimDetails from './CargoClaimDetails';

export default CargoClaimDetails;
